// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\components\\\\pages\\\\locations\\\\PlanYourVisitSection\\\\components\\\\ClockIcon.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\components\\pages\\locations\\PlanYourVisitSection\\components\\ClockIcon.tsx");
  import.meta.hot.lastModified = "1757171103328.2522";
}
// REMIX HMR END

export function ClockIcon() {
  return <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.125 10.7656C18.125 7.875 16.5625 5.21875 14.0625 3.73438C11.5234 2.28906 8.4375 2.28906 5.9375 3.73438C3.39844 5.21875 1.875 7.875 1.875 10.7656C1.875 13.6953 3.39844 16.3516 5.9375 17.8359C8.4375 19.2812 11.5234 19.2812 14.0625 17.8359C16.5625 16.3516 18.125 13.6953 18.125 10.7656ZM0 10.7656C0 7.21094 1.875 3.92969 5 2.13281C8.08594 0.335938 11.875 0.335938 15 2.13281C18.0859 3.92969 20 7.21094 20 10.7656C20 14.3594 18.0859 17.6406 15 19.4375C11.875 21.2344 8.08594 21.2344 5 19.4375C1.875 17.6406 0 14.3594 0 10.7656ZM9.0625 5.45312C9.0625 4.94531 9.45312 4.51562 10 4.51562C10.5078 4.51562 10.9375 4.94531 10.9375 5.45312V10.2969L14.2578 12.4844C14.6875 12.7969 14.8047 13.3828 14.5312 13.8125C14.2188 14.2422 13.6328 14.3594 13.2031 14.0469L9.45312 11.5469C9.21875 11.3906 9.0625 11.0781 9.0625 10.7656V5.45312Z" fill="#121212" fillOpacity="0.4" />
    </svg>;
}
_c = ClockIcon;
var _c;
$RefreshReg$(_c, "ClockIcon");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;